import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function BeforeAfter() {
  return <section className="w-full py-12 bg-gray-50" data-id="element-11">
      <div className="max-w-4xl mx-auto px-4" data-id="element-12">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-gray-800 mb-10" data-id="element-13">
          Die Entdeckung: Ein Zufall verändert alles
        </h2>
        <div className="prose prose-lg max-w-none mb-10" data-id="element-14">
          <p data-id="element-15">
            Oktober 2024. Meine Schwägerin aus Österreich besuchte uns und war
            schockiert von meinem Tabletten-Ritual. Sie erzählte mir von
            Ansätzen aus der Traditionellen Chinesischen Medizin. In jener Nacht
            googelte ich wie besessen: "Schmerzfrei ohne Medikamente", "Fuß
            Schmerzen natürlich heilen". Ich stieß auf Berichte über Akupressur
            und fand deutsche Foren mit Erfahrungsberichten über
            TianSole-Einlegesohlen.
          </p>
          <div className="border-l-4 border-teal-600 pl-4 italic text-lg text-gray-700 my-6" data-id="element-16">
            Ein Bericht elektrisierte mich: "Mein Name ist Klaus, 58, aus
            München. 6 Jahre lang 8 Schmerztabletten täglich. Dann TianSole
            probiert. Nach 4 Wochen komplett medikamentenfrei. Mein Orthopäde
            kann es nicht erklären, aber die Röntgenbilder zeigen deutliche
            Besserung..."
          </div>
          <p data-id="element-17">
            Am 7. November 2024 traf ich eine Entscheidung: "Was habe ich noch
            zu verlieren?"
          </p>
        </div>
        <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-gray-800 mb-8" data-id="element-18">
          Die Transformation: 30 Tage, die mein Leben veränderten
        </h3>
        <div className="prose prose-lg max-w-none mb-8" data-id="element-19">
          <p data-id="element-20">
            Was dann geschah, übertraf alle meine Erwartungen. Mit deutscher
            Gründlichkeit dokumentierte ich jeden Tag:
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-21">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-22">
            <h4 className="text-xl font-bold text-red-700 mb-4" data-id="element-23">Vorher:</h4>
            <img src="https://images.unsplash.com/photo-1512069772995-ec65ed45afd6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80" alt="Verschiedene Tabletten und Medikamente" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-24" />
            <ul className="space-y-2 text-gray-700" data-id="element-25">
              <li className="flex items-start" data-id="element-26">
                <span className="text-red-500 mr-2" data-id="element-27">✕</span>
                <span data-id="element-28">12 Schmerztabletten täglich</span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <span className="text-red-500 mr-2" data-id="element-30">✕</span>
                <span data-id="element-31">Ständige Fußschmerzen</span>
              </li>
              <li className="flex items-start" data-id="element-32">
                <span className="text-red-500 mr-2" data-id="element-33">✕</span>
                <span data-id="element-34">Chronische Entzündung</span>
              </li>
              <li className="flex items-start" data-id="element-35">
                <span className="text-red-500 mr-2" data-id="element-36">✕</span>
                <span data-id="element-37">Schlafprobleme</span>
              </li>
              <li className="flex items-start" data-id="element-38">
                <span className="text-red-500 mr-2" data-id="element-39">✕</span>
                <span data-id="element-40">Leberfunktionsstörungen</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-41">
            <h4 className="text-xl font-bold text-green-700 mb-4" data-id="element-42">Nachher:</h4>
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/etRU8ZiFACoQJRXx2HywZi/ChatGPT_Image_15._Juni_2025%2C_16_53_03.png" alt="Spezialisierte Einlegesohle mit roten und blauen Akupressurpunkten" className="w-full h-48 object-cover rounded-md mb-4" data-id="element-43" />
            <ul className="space-y-2 text-gray-700" data-id="element-44">
              <li className="flex items-start" data-id="element-45">
                <span className="text-green-500 mr-2" data-id="element-46">✓</span>
                <span data-id="element-47">0 Schmerztabletten</span>
              </li>
              <li className="flex items-start" data-id="element-48">
                <span className="text-green-500 mr-2" data-id="element-49">✓</span>
                <span data-id="element-50">Schmerzfrei</span>
              </li>
              <li className="flex items-start" data-id="element-51">
                <span className="text-green-500 mr-2" data-id="element-52">✓</span>
                <span data-id="element-53">Keine Entzündungszeichen</span>
              </li>
              <li className="flex items-start" data-id="element-54">
                <span className="text-green-500 mr-2" data-id="element-55">✓</span>
                <span data-id="element-56">Erholsamer Schlaf</span>
              </li>
              <li className="flex items-start" data-id="element-57">
                <span className="text-green-500 mr-2" data-id="element-58">✓</span>
                <span data-id="element-59">Normale Leberwerte</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-md mb-10" data-id="element-60">
          <h4 className="text-xl font-bold text-gray-800 mb-4" data-id="element-61">
            Mein 30-Tage-Fortschritt:
          </h4>
          <div className="space-y-4" data-id="element-62">
            <div className="border-l-4 border-teal-500 pl-4" data-id="element-63">
              <p className="font-bold" data-id="element-64">Woche 1:</p>
              <p data-id="element-65">
                Weniger Morgenschmerzen. Statt 4 Tabletten nur noch 3. Erster
                medikamentenfreier Vormittag seit 4 Jahren!
              </p>
            </div>
            <div className="border-l-4 border-teal-500 pl-4" data-id="element-66">
              <p className="font-bold" data-id="element-67">Woche 2:</p>
              <p data-id="element-68">
                Morgendliche Ibuprofen weggelassen. Schmerzen erträglich! Nur
                noch 6 Tabletten täglich.
              </p>
            </div>
            <div className="border-l-4 border-teal-500 pl-4" data-id="element-69">
              <p className="font-bold" data-id="element-70">Woche 3:</p>
              <p data-id="element-71">
                Reduktion auf 4 Tabletten. Erste komplett schmerzfreie Stunden
                seit Jahren.
              </p>
            </div>
            <div className="border-l-4 border-green-600 pl-4" data-id="element-72">
              <p className="font-bold" data-id="element-73">Tag 21:</p>
              <p className="font-bold text-green-700" data-id="element-74">
                Revolution! Erster komplett medikamentenfreier Tag!
              </p>
            </div>
            <div className="border-l-4 border-green-700 pl-4" data-id="element-75">
              <p className="font-bold" data-id="element-76">Woche 4:</p>
              <p className="font-bold text-green-700" data-id="element-77">
                Komplett medikamentenfrei. Keine Schmerzen. Keine
                Nebenwirkungen. Keine Tabletten.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-teal-50 border border-teal-100 p-6 rounded-lg" data-id="element-78">
          <h3 className="text-xl font-bold text-teal-800 mb-4" data-id="element-79">
            Der Moment der Wahrheit: Was die zwei Röntgenbilder enthüllten
          </h3>
          <p className="mb-4" data-id="element-80">
            "Frau Weber, ich möchte neue Röntgenaufnahmen machen." 20 Minuten
            später starrte Dr. Mueller auf die zwei Bildschirme. Links: Meine
            Füße vom März 2024. Rechts: Meine Füße vom November 2024.
            Minutenlanges Schweigen. Dann drehte er sich zu mir um.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-81">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aUZ9bW3gxcuDtvwVzgiBW7/117_2020_664_Fig5_HTML.png" alt="Medizinische Bildgebung des Fußes" className="w-full rounded-lg shadow-md" data-id="element-82" />
          </div>
          <div className="border-l-4 border-teal-600 pl-4 italic text-lg text-gray-700 my-4" data-id="element-83">
            "Frau Weber...", begann er zögerlich und wechselte ungläubig
            zwischen den Bildern. "Die Anzeichen für chronische
            Entzündungsprozesse sind dramatisch zurückgegangen", murmelte er,
            mehr zu sich selbst. "Die Weichteile sind nicht mehr geschwollen,
            die Reizung an der Faszie ist kaum noch zu erkennen. Ich kann mir
            das nicht erklären, aber das sind die Füße eines gesunden Menschen."
          </div>
          <p data-id="element-84">
            Er sah mich an: "In 25 Jahren Praxis habe ich eine solch
            erstaunliche Veränderung noch nie gesehen. Was um Himmels willen
            haben Sie gemacht?"
          </p>
        </div>
      </div>
    </section>;
}